export const calDays = (date: Array<string>) => {

    let inicion = new Date(date[0]).getTime()
    let fin = new Date(date[1]).getTime()
    const diferenciaEnMilisegundos = fin - inicion;
    const dias = Math.floor(diferenciaEnMilisegundos / (1000 * 60 * 60 * 24));

    return dias

}